import { useCallback, useMemo, useSyncExternalStore } from 'react'
import { Platform, Pressable, Text, View } from 'react-native'
import {
  getImpersonationSession,
  setImpersonationSession,
  subscribeImpersonationSession,
} from '../../src/zportiAdmin/helpers/impersonationToken.helper'
import { WEBSITE_UNIMPERSONATE_PATH } from '../../src/zportiAdmin/constants/impersonationRoute.constants'
import { GLOBAL_MENU_IMPERSONATION } from '../layout/globalMenuModal.constants'
import { useTheme } from '../../src/theme/useTheme'
import { getLandingMarketingImpersonationBannerStyles } from './LandingMarketingImpersonationBanner.styles'

/**
 * Web marketing: when an impersonation session is active, show a thin strip with exit
 * so operators are not stuck (the in-product menu is not on `/`).
 */
export function LandingMarketingImpersonationBanner() {
  const theme = useTheme()
  const styles = useMemo(() => getLandingMarketingImpersonationBannerStyles(theme), [theme])
  const session = useSyncExternalStore(
    subscribeImpersonationSession,
    getImpersonationSession,
    getImpersonationSession,
  )

  const handleExit = useCallback(() => {
    setImpersonationSession(null)
    if (typeof window !== 'undefined') {
      window.location.href = WEBSITE_UNIMPERSONATE_PATH
    }
  }, [])

  if (Platform.OS !== 'web' || !session?.token) return null

  const label = session.targetLabel?.trim() || 'another user'

  return (
    <View style={styles.wrap} accessibilityRole="summary">
      <Text style={styles.text} numberOfLines={2}>
        {GLOBAL_MENU_IMPERSONATION.VIEWING_AS_PREFIX} {label}.
      </Text>
      <Pressable
        onPress={handleExit}
        style={({ pressed }) => [styles.exitBtn, pressed && styles.exitBtnPressed]}
        accessibilityRole="button"
        accessibilityLabel={GLOBAL_MENU_IMPERSONATION.EXIT_IMPERSONATION}
        testID="landing-marketing-exit-impersonation"
      >
        <Text style={styles.exitBtnText}>{GLOBAL_MENU_IMPERSONATION.EXIT_IMPERSONATION}</Text>
      </Pressable>
    </View>
  )
}
